"use client";

import React from "react";
import { ExternalLink } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * GastronomyWebsite — Section 5: Beispiel-Mockup
 * Drop-in für: src/pages/GastronomyWebsite/sections/BeispielMockup.tsx
 *
 * 3-Device-Mockup (Desktop + Tablet + Mobile) mit Zurich's Resto Demo.
 */

const RESTAURANT_IMG = "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/restaurant.png-scaled.jpg?v=j1jzzezydc";
export default function BeispielMockup() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="beispiel-mockup" className="bg-secondary py-20 md:py-24 overflow-hidden">
      <style>{`
        .gw-device-desktop{background:#fff;border-radius:12px;box-shadow:0 25px 50px -12px rgba(0,0,0,.15);overflow:hidden;border:1px solid #e5e7eb}
        .gw-device-tablet{background:#1a1c23;border-radius:20px;padding:10px;box-shadow:0 20px 40px -10px rgba(0,0,0,.2)}
        .gw-device-tablet .screen{background:#fff;border-radius:8px;overflow:hidden}
        .gw-device-mobile{background:#1a1c23;border-radius:28px;padding:6px;box-shadow:0 20px 40px -10px rgba(0,0,0,.2)}
        .gw-device-mobile .screen{background:#fff;border-radius:20px;overflow:hidden}
        .gw-device-mobile .notch{width:40%;height:4px;background:#2a2c33;border-radius:4px;margin:4px auto 2px}
      `}</style>

      <div ref={ref} className={`max-w-6xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-14">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            So könnte Ihre Website aussehen
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Erstellt in wenigen Minuten — perfekt auf jedem Gerät.
          </p>
        </div>

        <div className="flex items-end justify-center gap-4 md:gap-8 max-w-5xl mx-auto">
          {/* Desktop */}
          <div className="hidden md:block" style={{
          width: "58%"
        }}>
            <div className="gw-device-desktop">
              <div className="h-8 bg-gray-100 border-b border-gray-200 flex items-center px-3 gap-1.5">
                <div className="w-2.5 h-2.5 rounded-full bg-red-300" />
                <div className="w-2.5 h-2.5 rounded-full bg-yellow-300" />
                <div className="w-2.5 h-2.5 rounded-full bg-green-300" />
                <div className="mx-auto text-[10px] text-gray-400 font-medium">
                  zurichresto.ch
                </div>
              </div>
              <div className="aspect-[16/10] overflow-hidden bg-gray-100">
                <img src={RESTAURANT_IMG} alt="Restaurant Website Desktop" className="w-full h-full object-cover object-top" />
              </div>
            </div>
            <p className="text-center text-xs text-muted-foreground mt-3 font-medium">
              Desktop
            </p>
          </div>

          {/* Tablet */}
          <div className="hidden md:block" style={{
          width: "22%"
        }}>
            <div className="gw-device-tablet">
              <div className="screen aspect-[3/4] overflow-hidden">
                <img src={RESTAURANT_IMG} alt="Restaurant Website Tablet" className="w-full h-full object-cover object-top" />
              </div>
            </div>
            <p className="text-center text-xs text-muted-foreground mt-3 font-medium">
              Tablet
            </p>
          </div>

          {/* Mobile */}
          <div className="flex-shrink-0" style={{
          width: "14%",
          minWidth: "110px"
        }}>
            <div className="gw-device-mobile">
              <div className="screen">
                <div className="notch" />
                <div className="aspect-[9/16] overflow-hidden">
                  <img src={RESTAURANT_IMG} alt="Restaurant Website Mobile" className="w-full h-full object-cover object-top" />
                </div>
              </div>
            </div>
            <p className="text-center text-xs text-muted-foreground mt-3 font-medium">
              Mobile
            </p>
          </div>
        </div>

        <div className="text-center mt-10">
          <a href="https://closing-starfish.my-pagemaker24.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary font-medium hover:underline text-lg">
            Live-Demo ansehen
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>;
}